import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const BaseWidgetActionOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  transition: color 0.3s ease-in-out;
  width: 16px;
  height: 16px;

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}

  &:hover {
    color: ${ct({ Dark: Colors.BrandBlueMiddle, Light: Colors.BrandBlueMiddle })};
  }
`;
